import { useEffect, useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'src/utils/i18n'
import { Select, Spin, Input } from 'antd'
import ExtremeVerfiyCommponents from './style'

import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  sendDownloadTime,
  iosLoginVerification,
  getAllUserDevice
} from 'src/@api/login'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import { isUnboundPackageSelectionActive } from 'src/utils/resolveCurrentOrderId'
import { MessageInfo } from 'src/components/pop-up-window'
import { messageInfo } from 'src/components/Message'
import { fetchResetTime, changeDownloadTips, changeBasicVerfiyOver, changeExtremeService } from 'src/store/apps/Common'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('src/@core/components/common/codeBox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

const ExtremeVerfiy = ({ setJustVerified }) => {

  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const [loginLoading, setLoginLoading] = useState(false) // 验证中状态
  const [current, setCurrent] = useState(0) // 当前验证的步骤，发送验证码 or 填写验证码
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度
  const [showPassword, setShowPassword] = useState(false)
  const [passwordError, setPasswordError] = useState('')

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [smsId, setSmsId] = useState('')
  const [key, setKey] = useState('1')
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案
  const [codeErrorText, setCodeErrorText] = useState('')
  const [codeBoxKey, setCodeBoxKey] = useState(0)

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)

  const [user, setUser] = useState(() => {
    return JSON.parse(localStorage.getItem("DeviceUser")) || {}
  })

  const getLoginCountry = () =>
    (JSON.parse(localStorage.getItem('userData'))?.data?.country_name || '').toLocaleLowerCase()

  const persistUserCredentials = (username, password) => {
    const nextUser = { ...user, username, password }
    setUser(nextUser)
    window.localStorage.setItem('DeviceUser', JSON.stringify(nextUser))

    return nextUser
  }

  const applyExtremeTwoStepVerification = (data, username, password) => {
    persistUserCredentials(username, password)
    MessageInfo(data.em)
    setCurrent(1)

    if (data?.ecurityType == 2) setKey('2')

    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(
        data.trustedPhoneNumbers.map(item => ({
          ...item,
          value: item.id,
          label: item.numberWithDialCode,
        }))
      )
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      if (data?.ecPhoneList === 0) {
        setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
      } else {
        setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
      }
    }

    setSmsPhoneListLoading(false)
  }

  const finishExtremeDirectSuccess = async (data, username, password) => {
    persistUserCredentials(username, password)
    MessageInfo({ content: data.em, type: 'success' })

    const updateRes = await updateDeviceCredentials({
      username,
      password,
      verify: 1,
    })

    if (!isUpdateCredentialsOk(updateRes)) {
      MessageInfo({ content: updateRes?.msg || data.em, type: 'error' })

      return
    }

    window.localStorage.setItem('Advanced', 1)
    dispatch(changeDownloadTips(true))
    dispatch(changeBasicVerfiyOver(false))
    dispatch(changeExtremeService(false))
    setJustVerified(true)

    await downloadWeb({ mode: 2, username, password })
    await sendDownloadTime({ username, type: 'advanced_download' })
    setTimeout(() => {
      dispatch(fetchResetTime())
    }, 800)
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 2,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => {
      applyExtremeTwoStepVerification(data, username, password)
    },
    onDirectSuccess: async ({ data, username, password }) => {
      await finishExtremeDirectSuccess(data, username, password)
    },
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  useEffect(() => {
    let cancelled = false

    const checkAndUpdateUser = async () => {
      if (user.username && user.password) return
      // 侧栏已选空包：禁止回填已绑定设备，否则冲掉空包选中态
      if (isUnboundPackageSelectionActive()) return

      const allDeviceUser = (await getAllUserDevice({})) || []
      if (cancelled || isUnboundPackageSelectionActive()) return

      const data = Array.isArray(allDeviceUser.data) ? allDeviceUser.data : []
      const iosUser = data.find(item => item.platform_type === 'iOS-Cloud')

      if (iosUser) {
        const newUser = {
          ...user,
          username: iosUser.iCloud_username,
          password: iosUser.iCloud_password
        }
        setUser(newUser)
        localStorage.setItem('DeviceUser', JSON.stringify(newUser))
      }
    }

    checkAndUpdateUser()

    return () => {
      cancelled = true
    }
  }, [])

  // 发送设备码（Step1 → 若需二步验证则同页进入 Step2）
  const sendCode = async () => {
    if (!user.username || !user.password) {
      setPasswordError(t('Value cannot be empty'))

      return
    }

    setLoginLoading(true)
    setPasswordError('')

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
      })
      data = res?.data
    } catch (e) {
      console.error('[extreme-verfiy2 sendCode] iosLoginVerification failed', e)
      setLoginLoading(false)
      MessageInfo({ content: e?.data?.em || t('Network error, please try again'), type: 'error' })

      return
    }

    setLoginLoading(false)

    // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
    if (!data || typeof data !== 'object') {
      MessageInfo({ content: t('Network error, please try again'), type: 'error' })

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setPasswordError(data.em || t('Incorrect username or password'))
      setLoginLoading(false)
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      setLoginLoading(false)
      MessageInfo(data.em)
      setCurrent(1)
      if (data?.ecurityType == 2) setKey('2')
      if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      setLoginLoading(false)
      await handleEc10005({ username: user.username, password: user.password })
    } else if (isIcloudOk(data)) {
      setLoginLoading(false)

      MessageInfo({ content: data.em, type: 'success' })

      const updateRes = await updateDeviceCredentials({
        username: user.username,
        password: user.password,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        MessageInfo({ content: updateRes?.msg || data.em, type: 'error' })

        return
      }

      window.localStorage.setItem('Advanced', 1)

      // 设置允许正在下载提示信息弹窗
      dispatch(changeDownloadTips(true))

      // 设置一步验证结束状态
      dispatch(changeBasicVerfiyOver(false))

      // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
      dispatch(changeExtremeService(false))

      // 设置为刚完成验证
      setJustVerified(true)

      let downloadRes = await downloadWeb({
        mode: 2,
        username: user.username,
        password: user.password
      })

      await sendDownloadTime({ username: user.username, type: 'advanced_download' })
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)
    } else {
      setPasswordError(data?.em || t('Incorrect username or password'))
    }
  }

  // 验证设备码
  const codeDevice = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setCodeErrorText('')
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        const updateRes = await updateDeviceCredentials({
          username: user.username,
          password: user.password,
          verify: 1
        })

        if (!isUpdateCredentialsOk(updateRes)) {
          MessageInfo({ content: updateRes?.msg || 'Update failed, please try again', type: 'error' })

          return
        }

        window.localStorage.setItem('Advanced', 1)

        let verify = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          setCodeErrorText(t('Network error, please try again'))
          setCodeBoxKey(k => k + 1)

          return
        }

        if (isIcloudOk(verify.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
          dispatch(changeExtremeService(false))

          // 设置为刚完成验证
          setJustVerified(true)

          let downloadRes = await downloadWeb({ mode: 2, username: user.username, password: user.password })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)
        } else {
          handlePasswordError(verify.data.ec)
          const tip = verify.data.em || t('Incorrect verification code Please try again')
          setCodeErrorText(tip)
          setCodeBoxKey(k => k + 1)
        }
      } catch (err) {
        console.error('[extreme-verfiy2 codeDevice] failed', err)
        setCodeErrorText(err?.data?.em || t('Network error, please try again'))
        setCodeBoxKey(k => k + 1)
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 手机号列表选择更改
  const handleSelectChange = value => {
    setSmsId(value)
  }

  // 发送短信验证码
  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const result = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        phoneID: smsId,
        country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = result?.data?.ec
      if (!isIcloudSendOk(ec)) {
        handlePasswordError(ec)
        messageInfo(result?.data?.em || 'Failed to send the verification code, please try again')
        return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(`SMS has been sent, please receive`)
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      messageInfo(e?.data?.em || 'Failed to send the verification code, please try again')
    }
  }

  // 验证短信验证码
  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setCodeErrorText('')
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let result = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          phoneID: smsId,
          country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          setCodeErrorText(t('Network error, please try again'))
          setCodeBoxKey(k => k + 1)

          return
        }

        if (isIcloudOk(result.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
          dispatch(changeExtremeService(false))

          // 设置为刚完成验证
          setJustVerified(true)

          let downloadRes = await downloadWeb({
            mode: 2,
            username: user.username,
            password: user.password
          })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)

          window.localStorage.setItem('Advanced', 1)
        } else {
          handlePasswordError(result.data.ec)
          const tip = result.data.em || t('Incorrect verification code Please try again')
          setCodeErrorText(tip)
          setCodeBoxKey(k => k + 1)
        }
      } catch (err) {
        console.error('[extreme-verfiy2 codeSms] failed', err)
        setCodeErrorText(err?.data?.em || t('Network error, please try again'))
        setCodeBoxKey(k => k + 1)
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  return (
    <ExtremeVerfiyCommponents className={`w-full ${current == 0 ? 'max-w-[544px] Mlg:px-[12px]' : 'max-w-[440px] Mlg:px-[24px]'} h-max`}>

      {/* apple Icon */}
      <Image src='/images/apps/apple.svg' alt='img' className='w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]' width='60' height='69' />

      {
        current == 0 ?
          <>
            {/* Step1：样式对齐 Extreme Data Verification 弹窗 B；发码后同页进 Step2 */}
            <h2 className='mt-6 text-center text-[20px] font-semibold leading-[28px] text-[#020417] lg:text-[24px] lg:leading-9'>
              {t('Extreme Data Verification')}
            </h2>

            <div className='mt-6 flex w-full max-w-[350px] flex-col gap-2.5 Mlg:max-w-full'>
              <div className='flex flex-col gap-2.5'>
                <label className='text-[16px] font-medium leading-6 text-[#020417]'>{t('Apple ID')}</label>
                <div className='flex items-center justify-between rounded-[8px] border border-[#E9EFF3] bg-[rgba(244,245,246,0.92)] px-4 py-2'>
                  <Input
                    bordered={false}
                    className='!p-0 text-[16px] leading-6 text-[#020417]'
                    value={user.username || ''}
                    disabled
                    placeholder={t('Apple ID')}
                  />
                </div>
              </div>

              <div className='flex flex-col gap-1'>
                <label className='text-[16px] font-medium leading-6 text-[#020417]'>{t('Password')}</label>
                <div
                  className={`flex h-10 items-center justify-between rounded-[8px] border px-4 py-2 ${
                    passwordError ? 'border-[#FF4C4C]' : 'border-[#E9EFF3]'
                  }`}
                >
                  <Input
                    bordered={false}
                    type={showPassword ? 'text' : 'password'}
                    className='!p-0 text-[16px] leading-6 text-[#020417] placeholder:text-[#BBBFca]'
                    value={user.password || ''}
                    onChange={e => {
                      setPasswordError('')
                      persistUserCredentials(user.username, e.target.value)
                    }}
                    placeholder={t('Password')}
                  />
                  <button
                    type='button'
                    className='ml-2 shrink-0'
                    onClick={() => setShowPassword(prev => !prev)}
                    aria-label='toggle password'
                  >
                    <Image
                      src={showPassword ? '/extreme/open.svg' : '/extreme/close.svg'}
                      alt=''
                      width={24}
                      height={24}
                      className='h-6 w-6'
                    />
                  </button>
                </div>
                {passwordError ? (
                  <p className='text-right text-[12px] leading-normal text-[#FF4C4C]'>{passwordError}</p>
                ) : null}
              </div>
            </div>

            <div className='mt-6 flex w-full max-w-[350px] items-start gap-2.5 rounded-[12px] bg-[rgba(74,119,254,0.1)] p-3 Mlg:max-w-full'>
              <Image
                src='/images/ios-locked/info-icon.svg'
                alt=''
                width={24}
                height={24}
                className='mt-0.5 h-6 w-6 shrink-0'
              />
              <p className='text-[14px] leading-5 text-[#4A77FE]'>
                {t(
                  'Once verified Apple will send a two-factor verification code or SMS to the monitored device Please ensure the device can receive messages'
                )}
              </p>
            </div>

            <div className='mt-8 flex w-full max-w-[350px] flex-col items-center Mlg:max-w-full'>
              <button
                type='button'
                disabled={loginLoading}
                className={`w-full rounded-[40px] bg-[#FFCF55] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#020417] lg:w-[240px] ${
                  loginLoading ? 'opacity-70' : ''
                }`}
                onClick={() => {
                  if (loginLoading) return
                  sendCode()
                }}
              >
                {t('Send Code')}
                {loginLoading && (
                  <span className='ml-3 inline-block h-5 w-5 animate-spin rounded-full border-[3px] border-white border-b-[#FFCF55]' />
                )}
              </button>
            </div>
          </>
          :
          <>
            <p className='max-w-[484px] text-[20px] mt-[26px] Mlg:mt-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>
              {t('Choose a Verification Method')}
            </p>
            <div className='w-[310px] Mlg:w-full'>
              <div className='w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]'>
                <div
                  className={`${key == '1'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } h-[27px] border-b-[2px] flex items-center cursor-pointer`}
                  onClick={() => {
                    if (key == '1') return
                    setCodeErrorText('')
                    setKey('1')
                  }}
                >
                  {t('Device')}
                </div>
                <div
                  className={`${key == '2'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer`}
                  onClick={() => {
                    if (key == '2') return
                    if (smsPhoneListDisabled) {
                      MessageInfo(smsErrorText)
                    } else {
                      setCodeErrorText('')
                      setKey('2')
                    }
                  }}
                >
                  {t('SMS')}
                </div>
              </div>
              {key == '1' && (
                <>
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`device-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeDevice} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('A verification code has been sent to the target iPhone Enter the verification code')}
                  </p>
                </>
              )}
              {key == '2' && (
                <>
                  <div className='h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex'>
                    <Select
                      defaultValue={defaultSmsPhone}
                      style={{
                        flex: 1,
                        height: '100%'
                      }}
                      suffixIcon={
                        smsPhoneListLoading ? (
                          <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                        ) : (
                          <Image
                            className='mr-[5px]'
                            src='/images/user-verify/dropdown.svg'
                            width={14}
                            height={0}
                            alt='dropDown'
                          />
                        )
                      }
                      disabled={smsPhoneListDisabled}
                      onChange={handleSelectChange}
                      options={smsPhoneList}
                    />
                    <button
                      disabled={btnDisable}
                      className='w-full max-w-max min-w-[85px] h-full flex justify-center items-center'
                      style={{
                        opacity: btnDisable ? 0.7 : 1,
                        background: '#FFCF55',
                        padding: '0px 21px',
                        marginLeft: '10px',
                        color: '#1B1C2B',
                        borderRadius: '41px',
                        fontSize: '18px'
                      }}
                      onClick={sendSms}
                    >
                      {btnDisable ? sendTime : t('Send')}
                    </button>
                  </div>

                  {sendContentTips != '' && (
                    <p className='text-center mb-[24px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                  )}
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`sms-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeSms} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('Enter the verification code')}
                  </p>
                </>
              )}
            </div>
          </>
      }
      {lockedFlowModals}
    </ExtremeVerfiyCommponents>
  )
}

export default ExtremeVerfiy
